import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

/**
 * Fetches the duration of a remote MP4 file (in seconds)
 * and formats it as Hh Mm Ss (e.g., 1h 05m 12s).
 */
export default function VideoDuration({ src, onDuration }) {
  const [duration, setDuration] = useState(null);

  useEffect(() => {
    if (!src) return;

    const video = document.createElement("video");
    video.preload = "metadata";
    video.src = src;
    video.onloadedmetadata = () => {
      const d = video.duration; // seconds
      setDuration(d);
      if (onDuration) onDuration(d);
    };
    video.onerror = () => setDuration(null);
  }, [src, onDuration]);

  if (duration == null) return null;

  // ---- Format with hours, minutes, seconds ----
  const totalSeconds = Math.round(duration);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  let formatted;
  if (hours > 0) {
    // Show all three parts if at least 1 hour
    formatted = `${hours}h ${minutes}m ${seconds}s`;
  } else if (minutes > 0) {
    formatted = `${minutes}m ${seconds}s`;
  } else {
    formatted = `${seconds}s`;
  }

  return <>{formatted}</>;
}

VideoDuration.propTypes = {
  src: PropTypes.string.isRequired,
  onDuration: PropTypes.func,
};
